import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action,selected) => {
    let body: "";
    let info=data[selected.id || 0] || []
    body = info.map((column, index) => {

        return (
            <tr key={index}>
                <td style={{textAlign:"center", width:50}}>
                <button className="btn btn-light" id="cbox2"  style={{minWidth: '100%'}} 
                 onClick={(event) => selected.selectOne(selected.id,index)}>
                    {column.ColumnName || ""}
                </button>
                    {/* <button 
                    style={{minWidth: '100%'}} 
                   
                   ></button> */}
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action,selected) => {
    let header = "";
    let body = "";
    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow" style={{textAlign:'center'}}>{headers[0].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action,selected);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderColumnsName = (headers, data, action,selected) => {
  
    return renderTable(headers, data, action,selected);

}
